import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { MaterialModule } from '../material/material.module';
import { AuditTableComponent } from './components/audit/table/audit-table.component';
import { AircraftFormComponent } from './components/basic/aircraft-form/aircraft-form.component';
import { AutocompleteComponent } from './components/basic/autocomplete/autocomplete.component';
import { CancelFeesDetailComponent } from './components/basic/cancel-fees-detail/cancel-fees-detail.component';
import { CheckboxComponent } from './components/basic/checkbox/checkbox.component';
import { AircraftFormEditModeComponent } from './components/basic/edit-mode/aircraft/aircraft.component';
import { AirportsSelectEditModeComponent } from './components/basic/edit-mode/airports/airports.component';
import { InputDateEditModeComponent } from './components/basic/edit-mode/input-date/input-date.component';
import { InputHourEditModeComponent } from './components/basic/edit-mode/input-hour/input-hour.component';
import { InputNumberEditModeComponent } from './components/basic/edit-mode/input-number/input-number.component';
import { SelectComponentEditMode } from './components/basic/edit-mode/select/select.component';
import { FlightStepsComponent } from './components/basic/flight-steps/flight-steps.component';
import { FlightTabComponent } from './components/basic/flight-tab/flight-tab.component';
import { InputHourInsideTableComponent } from './components/basic/input-hour-inside-table/input-hour-inside-table.component';
import { InputHourComponent } from './components/basic/input-hour/input-hour.component';
import { InputMaskComponent } from './components/basic/input-mask/input-mask.component';
import { InputPriceLabelComponent } from './components/basic/input-price-label/input-price-label.component';
import { InputPriceComponent } from './components/basic/input-price/input-price.component';
import { InputTextComponent } from './components/basic/input-text/input-text.component';
import { InputComponent } from './components/basic/input/input.component';
import { JoditEditorComponent } from './components/basic/jodit-editor/jodit-editor.component';
import { RouteGeneratorFormComponent } from './components/basic/route-generator-form/route-generator-form.component';
import { SearchAirportsInsideTableComponent } from './components/basic/search-airports-inside-table/search-airports-inside-table.component';
import { SearchAirportsComponent } from './components/basic/search-airports/search-airports.component';
import { SelectFormInsideTableComponent } from './components/basic/select-form-inside-table/select-form-inside-table.component';
import { SelectFormTooltipComponent } from './components/basic/select-form-tooltip/select-form-tooltip.component';
import { SelectFormComponent } from './components/basic/select-form/select-form.component';
import { SelectMultipleComponent } from './components/basic/select-multiple/select-multiple.component';
import { SelectComponent } from './components/basic/select/select.component';
import { SpanTextComponent } from './components/basic/span-text/span-text.component';
import { SwitchComponent } from './components/basic/switch/switch.component';
import { ToggleTimezoneHoursInlineComponent } from './components/basic/toggle-timezone-hours-inline/toggle-timezone-hours-inline.component';
import { AddPaxTaxLinesDialogComponent } from './components/dialogs/add-pax-tax-lines-dialog/add-pax-tax-lines-dialog.component';
import { AirportTaxLinesUpdateDialogComponent } from './components/dialogs/airport-tax-lines-update-dialog/airport-tax-lines-update-dialog.component';
import { AvailablePlacesDialogComponent } from './components/dialogs/available-places-dialog/available-places-dialog.component';
import { BrokersDistributionComponent } from './components/dialogs/brokers-distribution/brokers-distribution.component';
import { ConfirmCancelVoidFlightsDialogComponent } from './components/dialogs/confirm-cancel-void-flights-dialog/confirm-cancel-void-flights-dialog.component';
import { ConfirmOperationDialogComponent } from './components/dialogs/confirm-operation-dialog/confirm-operation-dialog.component';
import { ContractServiceConfigurationDialogComponent } from './components/dialogs/contract-service-configuration-dialog/contract-service-configuration-dialog.component';
import { InfoDialogComponent } from './components/dialogs/info-dialog/info-dialog.component';
import { MailsDialogComponent } from './components/dialogs/mails-dialog/mails-dialog.component';
import { MassiveChangesPlanningSlotsComponent } from './components/dialogs/massive-changes-planning-slots/massive-changes-planning-slots.component';
import { MassiveChangesPlanningComponent } from './components/dialogs/massive-changes-planning/massive-changes-planning.component';
import { MessageDialogComponent } from './components/dialogs/message-dialog/message-dialog.component';
import { NewOperatorDialogComponent } from './components/dialogs/new-operator-dialog/new-operator-dialog.component';
import { ObservationDialogComponent } from './components/dialogs/observation-dialog/observation-dialog.component';
import { PaxDialogComponent } from './components/dialogs/pax-dialog/pax-dialog.component';
import { PaymentExpirationDateUpdateDialogComponent } from './components/dialogs/payment-expiration-date-update-dialog/payment-expiration-date-update-dialog.component';
import { SelectActionDialogComponent } from './components/dialogs/select-action-dialog/select-action-dialog.component';
import { SelectCustomDialogComponent } from './components/dialogs/select-custom-dialog/select-custom-dialog.component';
import { SelectDialogComponent } from './components/dialogs/select-dialog/select-dialog.component';
import { EditModeDirective } from './components/editable/edit-mode.directive';
import { EditOnEnterDirective } from './components/editable/edit-on-enter.directive';
import { EditableComponent } from './components/editable/editable.component';
import { ViewModeDirective } from './components/editable/view-mode.directive';
import { AdvancedSearchComponent } from './components/menus/advanced-search/advanced-search.component';
import { ButtonBarComponent } from './components/menus/button-bar/button-bar.component';
import { LeftSidebarComponent } from './components/menus/left-sidebar/left-sidebar.component';
import { MobileBarComponent } from './components/menus/mobile-bar/mobile-bar.component';
import { PageBarComponent } from './components/menus/page-bar/page-bar.component';
import { SearchBarComponent } from './components/menus/search-bar/search-bar.component';
import { SortMenuComponent } from './components/menus/sort-menu/sort-menu.component';
import { TopBarComponent } from './components/menus/top-bar/top-bar.component';
import { ModalComponent } from './components/modal/modal.component';
import { TranslatedSnackBarComponent } from './components/snack-bar/translated-snack-bar/translated-snack-bar.component';
import { ColumnActionsComponent } from './components/table/components/column-actions/column-actions.component';
import { ColumnCheckboxComponent } from './components/table/components/column-checkbox/column-checkbox.component';
import { LetterTableComponent } from './components/table/components/letter-table/letter-table.component';
import { PaginationComponent } from './components/table/components/pagination/pagination.component';
import { SortButtonComponent } from './components/table/components/sort-button/sort-button.component';
import { TableComponent } from './components/table/table.component';
import { FocusableDirective } from './directives/focusable.directive';
import { HeaderStickyDirective } from './directives/header-sticky.directive';
import { MatCollapsibleDirective } from './directives/mat-collapsible.directive';
import { MatDropdownDirective } from './directives/mat-dropdown.directive';
import { MatTooltipDirective } from './directives/mat-tooltip.directive';
import { MaxlengthDirective } from './directives/maxlength.directive';
import { TableAuditTooltipDirective } from './directives/table-audit-tooltip.directive';
import { SearchAirportSelectPipe } from './pipes/search-airport-select.pipe';
import { SentenceCasePipe } from './pipes/sentence-case.pipe';
import { MassiveReassignFerryComponent } from './components/dialogs/massive-reassign-ferry/massive-reassign-ferry.component';
import { OfferHistoryDialogComponent } from './components/dialogs/offer-history-dialog/offer-history-dialog.component';
import { ContributionLinesComponent } from '../modules/dashboards/files/components/contribution-lines/contribution-lines.component';

@NgModule({
  declarations: [
    AdvancedSearchComponent,
    ButtonBarComponent,
    CheckboxComponent,
    CheckboxComponent,
    ColumnActionsComponent,
    ColumnCheckboxComponent,
    InputComponent,
    InputMaskComponent,
    InputPriceComponent,
    InputHourComponent,
    InputTextComponent,
    JoditEditorComponent,
    SpanTextComponent,
    LeftSidebarComponent,
    LetterTableComponent,
    MatCollapsibleDirective,
    MatDropdownDirective,
    MatTooltipDirective,
    MobileBarComponent,
    ModalComponent,
    PageBarComponent,
    PaginationComponent,
    SearchBarComponent,
    SelectComponent,
    SelectFormComponent,
    SearchAirportsComponent,
    SentenceCasePipe,
    SearchAirportSelectPipe,
    SortButtonComponent,
    SortMenuComponent,
    SwitchComponent,
    TableAuditTooltipDirective,
    TableComponent,
    AuditTableComponent,
    TopBarComponent,
    TranslatedSnackBarComponent,
    AutocompleteComponent,
    ToggleTimezoneHoursInlineComponent,
    FlightStepsComponent,
    RouteGeneratorFormComponent,
    CancelFeesDetailComponent,
    ConfirmOperationDialogComponent,
    AirportTaxLinesUpdateDialogComponent,
    AddPaxTaxLinesDialogComponent,
    ContractServiceConfigurationDialogComponent,
    ConfirmCancelVoidFlightsDialogComponent,
    SelectActionDialogComponent,
    InfoDialogComponent,
    EditableComponent,
    ViewModeDirective,
    EditModeDirective,
    EditOnEnterDirective,
    FocusableDirective,
    HeaderStickyDirective,
    MaxlengthDirective,
    SelectMultipleComponent,
    SelectFormInsideTableComponent,
    InputHourInsideTableComponent,
    SearchAirportsInsideTableComponent,
    FlightTabComponent,
    PaxDialogComponent,
    AircraftFormComponent,
    SelectFormTooltipComponent,
    InputPriceLabelComponent,
    InputDateEditModeComponent,
    AircraftFormEditModeComponent,
    AirportsSelectEditModeComponent,
    SelectComponentEditMode,
    InputHourEditModeComponent,
    InputNumberEditModeComponent,
    MessageDialogComponent,
    BrokersDistributionComponent,
    MailsDialogComponent,
    ObservationDialogComponent,
    SelectDialogComponent,
    MassiveChangesPlanningComponent,
    NewOperatorDialogComponent,
    MassiveChangesPlanningSlotsComponent,
    MassiveReassignFerryComponent,
    SelectCustomDialogComponent,
    AvailablePlacesDialogComponent,
    OfferHistoryDialogComponent,
    PaymentExpirationDateUpdateDialogComponent,
    ContributionLinesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    NgSelectModule,
    RouterModule,
    TranslateModule,
    NgxMaskModule,
  ],
  exports: [
    AutocompleteComponent,
    AdvancedSearchComponent,
    ButtonBarComponent,
    CheckboxComponent,
    InputComponent,
    InputMaskComponent,
    InputPriceComponent,
    InputHourComponent,
    InputTextComponent,
    JoditEditorComponent,
    SpanTextComponent,
    LeftSidebarComponent,
    MatCollapsibleDirective,
    MatDropdownDirective,
    MatTooltipDirective,
    MobileBarComponent,
    ModalComponent,
    PageBarComponent,
    SearchBarComponent,
    SelectComponent,
    SelectFormComponent,
    SearchAirportsComponent,
    SentenceCasePipe,
    SearchAirportSelectPipe,
    SortMenuComponent,
    SwitchComponent,
    TableAuditTooltipDirective,
    TableComponent,
    AuditTableComponent,
    ToggleTimezoneHoursInlineComponent,
    FlightStepsComponent,
    RouteGeneratorFormComponent,
    CancelFeesDetailComponent,
    TopBarComponent,
    TranslateModule,
    EditableComponent,
    ViewModeDirective,
    EditModeDirective,
    EditOnEnterDirective,
    FocusableDirective,
    HeaderStickyDirective,
    MaxlengthDirective,
    SelectMultipleComponent,
    SelectFormInsideTableComponent,
    InputHourInsideTableComponent,
    SearchAirportsInsideTableComponent,
    AircraftFormComponent,
    SelectFormTooltipComponent,
    InputPriceLabelComponent,
    InputDateEditModeComponent,
    AircraftFormEditModeComponent,
    AirportsSelectEditModeComponent,
    SelectComponentEditMode,
    InputHourEditModeComponent,
    InputNumberEditModeComponent,
    ContributionLinesComponent
  ],
})
export class CoreModule { }
